/** 导航卡片：初始图 / 效果图（public/images/ipe/nav-hub） */
import { getConceptPreviewVideoSources } from '@/pages/ipe/workbench/constants/videoConceptPresetPreviewVideos';

const BASE = '/images/ipe/nav-hub';

/** 与首页「核心能力 · AI视频」一致的演示素材 */
export const NAV_HUB_VIDEO_GENERATE_DEMO = {
  video: `${BASE}/video-generate-demo.mp4`,
  /** 视频不可用时回退（本地文件未生成时）；Mixkit 新 CDN 路径，旧 /preview/ 已 403 */
  videoFallback: 'https://assets.mixkit.co/videos/43462/43462-720.mp4',
  /** 与演示视频首帧一致的模特静图，用于图生视频过渡 */
  modelStill: `${BASE}/videos-result.webp`,
  /** @deprecated 使用 modelStill */
  poster: `${BASE}/videos-result.webp`,
};

/** 文生视频导航卡 / 功能页共用：图生视频「休闲走动」概念预览片源 */
const T2V_CASUAL_PREVIEW_SOURCES = getConceptPreviewVideoSources('casual');
export const NAV_HUB_TEXT_TO_VIDEO_DEMO = {
  video: T2V_CASUAL_PREVIEW_SOURCES[0] || '',
  videoFallback: T2V_CASUAL_PREVIEW_SOURCES[1] || T2V_CASUAL_PREVIEW_SOURCES[0] || '',
};

/** 与首页「核心能力 · Listing 文案」一致的演示图 */
export const NAV_HUB_LISTING_COPY_DEMO = `${BASE}/aiCopywriting-result.webp`;

/** 图生视频：导航卡与功能页空状态封面 */
export const NAV_HUB_VIDEO_I2V_COVER = `${BASE}/videoReplica-result.webp`;

/** 文生视频：导航卡与功能页空状态封面 */
export const NAV_HUB_VIDEO_T2V_COVER = `${BASE}/videoTranslate-result.webp`;

export const NAV_HUB_CARD_IMAGES = {
  img2img: {
    source: `${BASE}/img2img-source.webp`,
    result: `${BASE}/img2img-result.webp`,
    sourceLabel: '变长袖',
  },
  imageFission: { source: `${BASE}/imageFission-source.webp`, result: `${BASE}/imageFission-result.webp` },
  smartCutout: { source: `${BASE}/smartCutout-source.webp`, result: `${BASE}/smartCutout-result.webp` },
  imageEnhance: { source: `${BASE}/imageEnhance-source.webp`, result: `${BASE}/imageEnhance-result.webp` },
  imageCrop: { source: `${BASE}/imageCrop-source.webp`, result: `${BASE}/imageCrop-result.webp` },
  aiOutpaint: { source: `${BASE}/aiOutpaint-source.webp`, result: `${BASE}/aiOutpaint-result.webp` },
  aiTextToImage: { source: `${BASE}/aiTextToImage-source.webp`, result: `${BASE}/aiTextToImage-result.webp` },
  aiCopywriting: {
    result: NAV_HUB_LISTING_COPY_DEMO,
    layout: 'resultOnly',
  },
  videos: {
    result: NAV_HUB_VIDEO_I2V_COVER,
    layout: 'resultOnly',
  },
  textToVideo: {
    result: NAV_HUB_VIDEO_T2V_COVER,
    layout: 'resultOnly',
  },
  modelTryOn: {
    source: `${BASE}/modelTryOn-source.webp`,
    result: `${BASE}/modelTryOn-result.webp`,
    layout: 'split',
  },
  modelHandheld: { source: `${BASE}/modelHandheld-source.webp`, result: `${BASE}/modelHandheld-result.webp` },
  modelPoseFission: { source: `${BASE}/modelPoseFission-source.webp`, result: `${BASE}/modelPoseFission-result.webp` },
  modelUniversalWear: { source: `${BASE}/modelUniversalWear-source.webp`, result: `${BASE}/modelUniversalWear-result.webp` },
  platformShops: { source: `${BASE}/platformShops-source.webp`, result: `${BASE}/platformShops-result.webp` },
  platformListing: { source: `${BASE}/platformListing-source.webp`, result: `${BASE}/platformListing-result.webp` },
  platformListingJobs: {
    result: `${BASE}/platformListingJobs-result.webp`,
    layout: 'resultOnly',
  },
  platformScheduledListings: {
    result: `${BASE}/platformScheduledListings-result.webp`,
    layout: 'resultOnly',
  },
  ipeWorkflow: { source: `${BASE}/ipeWorkflow-source.webp`, result: `${BASE}/ipeWorkflow-result.webp` },
  ipeWorkflowTasks: { source: `${BASE}/ipeWorkflowTasks-source.webp`, result: `${BASE}/ipeWorkflowTasks-result.webp` },
  goods: { source: `${BASE}/goods-source.webp`, result: `${BASE}/goods-result.webp` },
  podProductDesign: { source: `${BASE}/podProductDesign-source.webp`, result: `${BASE}/podProductDesign-result.webp` },
  stampExtract: { source: `${BASE}/stampExtract-source.webp`, result: `${BASE}/stampExtract-result.webp` },
  patternFission: { source: `${BASE}/patternFission-source.webp`, result: `${BASE}/patternFission-result.webp` },
  imageCollection: { source: `${BASE}/imageCollection-source.webp`, result: `${BASE}/imageCollection-result.webp` },
  thirdPartyReceive: {
    result: `${BASE}/imageCollection-result.webp`,
    layout: 'resultOnly',
  },
  infringementDetection: {
    result: `${BASE}/infringementDetection-result.webp`,
    layout: 'resultOnly',
  },
  titles: { source: `${BASE}/titles-source.webp`, result: `${BASE}/titles-result.webp` },
  imageTemplates: { source: `${BASE}/imageTemplates-source.webp`, result: `${BASE}/imageTemplates-result.webp` },
  tableTemplates: { source: `${BASE}/listingTemplates-source.webp`, result: `${BASE}/listingTemplates-result.webp` },
  listingTemplates: { source: `${BASE}/listingTemplates-source.webp`, result: `${BASE}/listingTemplates-result.webp` },
  sourcingHub: { source: `${BASE}/sourcingHub-source.webp`, result: `${BASE}/sourcingHub-result.webp` },
  systemMaterialLibrary: { source: `${BASE}/systemMaterialLibrary-source.webp`, result: `${BASE}/systemMaterialLibrary-result.webp` },
  imageSpace: { source: `${BASE}/imageSpace-source.webp`, result: `${BASE}/imageSpace-result.webp` },
  downloadCenter: { source: `${BASE}/downloadCenter-source.webp`, result: `${BASE}/downloadCenter-result.webp` },
  teamManagement: { source: `${BASE}/teamManagement-source.webp`, result: `${BASE}/teamManagement-result.webp` },
  accountCenter: { source: `${BASE}/accountCenter-source.webp`, result: `${BASE}/accountCenter-result.webp` },
};
